// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__1n85l","label":"CategoryService_label__3iRwk","location":"CategoryService_location__2YR8c"};